<ms-competition-tree *rxIf="sport; else empty; renderCallback: render$" [sport]="sport" [context]="context" [tournaments]="tournaments" />
<ms-component-loader *rxIf="showLoader$; strategy: 'native'" />
<ng-template #empty> <ms-error severity="info" [message]="sitecore.event.ErrNoEventsPerSport" /> </ng-template>
